<template>
  <div>
    <el-row type="flex" class="row-bg" style="width:300px">
      <el-col :span="14" v-if="brandName!=''">
        <p>{{brandName}}</p>
      </el-col>
      <el-col :span="6">
        <el-button
          size="small"
          type="primary"
          icon="search"
          @click="dialogVisible = true"
          :disabled="doWhatTemp==='view'"
        >选择</el-button>
      </el-col>
      <el-col :span="4" v-if="brandName!=''">
        <el-button
          size="small"
          type="danger"
          @click="delBrand"
          icon="delete2"
          :disabled="doWhatTemp==='view'"
        >删除</el-button>
      </el-col>
    </el-row>
    <el-dialog title="选择品牌" :visible.sync="dialogVisible">
      <div>
        <el-input style="width: 300px; margin-bottom: 20px" v-model="brandNameTemp" />
        <el-table
          ref="brandTable"
          :data="brandList"
          highlight-current-row
          @current-change="handleCurrentChange"
          border
          tooltip-effect="dark"
          style="width: 100%"
          height="400"
        >
          <el-table-column prop="id" label="品牌ID" align="center" width="120"></el-table-column>
          <el-table-column prop="label" label="品牌名称" align="center" min-width="300"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="dialogConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
export default {
  name: "BrandChose",
  components: {},
  data() {
    return {
      brandList: [],
      brandId: null,
      tableRowTemp: null,
      dialogVisible: false,
      brandNameTemp: this.brandName,
    };
  },
  created() {
    this.fetchBrandList();
  },
  props: {
    brandName: {
      type: String,
      default: "",
    },
    doWhatTemp: {
      type: String,
      default: "",
    },
    tagIds: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    brandName(newVal) {
      this.brandNameTemp = newVal;
      this.findBrandIdByName(this.brandNameTemp);
      this.$emit(
        "brandChose",
        this.brandNameTemp,
        this.brandId
      );
    },
  },
  methods: {
    fetchBrandList() {
      let temp = {
        appId: this.$API.APPID,
        pid: 23,
        showAll: 1,
      };
      this.$axios
        .post("/aries-api/tag/list", temp)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.brandList = response.data.data;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    findBrandIdByName(name) {
      for (let i = 0; i < this.brandList.length; ++i) {
        if (this.brandList[i].label === name) {
          this.brandId = this.brandList[i].id;
          break;
        }
      }
    },
    dialogConfirm() {
      if (this.tableRowTemp != null) {
        this.brandNameTemp = this.tableRowTemp.label;
        this.brandId = this.tableRowTemp.id;
        this.tableRowTemp = null;
        this.$refs.brandTable.setCurrentRow(null);
        this.$emit(
          "brandChose",
          this.brandNameTemp,
          this.brandId
        );
      }
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.tableRowTemp = val;
      //this.brandNameTemp = val.label;
    },
    delBrand() {
      this.brandNameTemp = "";
      this.brandId = null;
      this.$emit(
        "brandChose",
        this.brandNameTemp,
        this.brandId
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// BrandChose.vue?f1724cc2